import { loadBooks } from "../actionCreator";

const fetchBooks = () => {
    return async (dispatch) => {
        const res = await fetch("http://localhost:9000/books");
        const data = await res.json();

        if(data.length) {
            dispatch(loadBooks(data))
        }
    }
}

export default fetchBooks;